import { render } from "./AppShell.vue?vue&type=template&id=46c2c947&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"

import "./AppShell.vue?vue&type=style&index=0&id=46c2c947&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c2c947"]])

export default __exports__